import { render } from "./component-reform-from.vue?vue&type=template&id=7621dda3"
import script from "./component-reform-from.vue?vue&type=script&setup=true&lang=js"
export * from "./component-reform-from.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-reform-from.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7621dda3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7621dda3', __exports__)) {
    api.reload('7621dda3', __exports__)
  }
  
  module.hot.accept("./component-reform-from.vue?vue&type=template&id=7621dda3", () => {
    api.rerender('7621dda3', render)
  })

}


export default __exports__